import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const UserList = Loadable(
  lazy(() => import("features/security/user/components/UserList"))
);
const UserPage = Loadable(
  lazy(() => import("features/security/user/components/UserPage"))
);
const ChangePassword = Loadable(
  lazy(() => import("features/security/user/components/ChangePassword"))
);

const RolesList = Loadable(
  lazy(() => import("features/security/roles/components/RoleList"))
);

const RolesPage = Loadable(
  lazy(() => import("features/security/roles/components/RolePage"))
);

const RolePermissions = Loadable(
  lazy(
    () => import("features/security/rolePermissions/components/RolePermissions")
  )
);

const routes = {
  path: "security",
  children: [
    { path: "user", element: <UserList /> },
    { path: "user/add", element: <UserPage /> },
    { path: "user/edit/:userID?", element: <UserPage /> },
    { path: "user/change-password", element: <ChangePassword /> },
    { path: "role", element: <RolesList /> },
    { path: "role/add", element: <RolesPage /> },
    { path: "role/edit/:id?", element: <RolesPage /> },
    { path: "permissions", element: <RolePermissions /> },
  ],
};

export default routes;
